/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Showcase_Rarestunlock1Inputs */

const id_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembukaan paling langka`)
};

const ms_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukaan paling jarang`)
};

const da_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjældneste oplåsning`)
};

const de_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seltenste Freischaltung`)
};

const en_us2_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rarest unlock`)
};

const es_es2_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueo más raro`)
};

const es_mx2_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueo más raro`)
};

const fil_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakabihirang unlock`)
};

const fr_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déblocage le plus rare`)
};

const it_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocco più raro`)
};

const hu_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legritkább feloldás`)
};

const nl_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeldzaamste ontgrendeling`)
};

const no_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjeldneste opplåsing`)
};

const pl_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najrzadsze odblokowanie`)
};

const pt_br2_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueio mais raro`)
};

const pt_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueio mais raro`)
};

const ro_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cea mai rară deblocare`)
};

const fi_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harvinaisin avaus`)
};

const sv_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sällsyntaste upplåsning`)
};

const vi_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở khóa hiếm nhất`)
};

const tr_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En nadir açılım`)
};

const cs_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejvzácnější odemčení`)
};

const bg_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-рядко отключване`)
};

const ru_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самое редкое достижение`)
};

const uk_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найрідкісніше розблокування`)
};

const ar_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أندر عملية فتح`)
};

const hi_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबसे दुर्लभ अनलॉक`)
};

const th_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การปลดล็อกที่หายากที่สุด`)
};

const ja_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最もレアな解除`)
};

const zh_cn2_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最稀有解锁`)
};

const zh_hant1_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最稀有解鎖`)
};

const ko_profile_showcase_rarestunlock1 = /** @type {(inputs: Profile_Showcase_Rarestunlock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가장 희귀한 잠금 해제`)
};

/**
* | output |
* | --- |
* | "Rarest unlock" |
*
* @param {Profile_Showcase_Rarestunlock1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_rarestunlock1 = /** @type {((inputs?: Profile_Showcase_Rarestunlock1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Rarestunlock1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_rarestunlock1(inputs)
	if (locale === "ms") return ms_profile_showcase_rarestunlock1(inputs)
	if (locale === "da") return da_profile_showcase_rarestunlock1(inputs)
	if (locale === "de") return de_profile_showcase_rarestunlock1(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_rarestunlock1(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_rarestunlock1(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_rarestunlock1(inputs)
	if (locale === "fil") return fil_profile_showcase_rarestunlock1(inputs)
	if (locale === "fr") return fr_profile_showcase_rarestunlock1(inputs)
	if (locale === "it") return it_profile_showcase_rarestunlock1(inputs)
	if (locale === "hu") return hu_profile_showcase_rarestunlock1(inputs)
	if (locale === "nl") return nl_profile_showcase_rarestunlock1(inputs)
	if (locale === "no") return no_profile_showcase_rarestunlock1(inputs)
	if (locale === "pl") return pl_profile_showcase_rarestunlock1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_rarestunlock1(inputs)
	if (locale === "pt") return pt_profile_showcase_rarestunlock1(inputs)
	if (locale === "ro") return ro_profile_showcase_rarestunlock1(inputs)
	if (locale === "fi") return fi_profile_showcase_rarestunlock1(inputs)
	if (locale === "sv") return sv_profile_showcase_rarestunlock1(inputs)
	if (locale === "vi") return vi_profile_showcase_rarestunlock1(inputs)
	if (locale === "tr") return tr_profile_showcase_rarestunlock1(inputs)
	if (locale === "cs") return cs_profile_showcase_rarestunlock1(inputs)
	if (locale === "bg") return bg_profile_showcase_rarestunlock1(inputs)
	if (locale === "ru") return ru_profile_showcase_rarestunlock1(inputs)
	if (locale === "uk") return uk_profile_showcase_rarestunlock1(inputs)
	if (locale === "ar") return ar_profile_showcase_rarestunlock1(inputs)
	if (locale === "hi") return hi_profile_showcase_rarestunlock1(inputs)
	if (locale === "th") return th_profile_showcase_rarestunlock1(inputs)
	if (locale === "ja") return ja_profile_showcase_rarestunlock1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_rarestunlock1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_rarestunlock1(inputs)
	return ko_profile_showcase_rarestunlock1(inputs)
});
export { profile_showcase_rarestunlock1 as "profile.showcase.rarestUnlock" }